/* Find My Size
   - Reads the size chart (JSON metafield) rendered inside each popup.
   - Recommends a size from the customer's measurements.
   - Saves the measurements in the browser, so on every product (any chart) the
     "Find My Size" link turns into "Your Size: M" and that size is auto-selected. */
(function () {
  if (window.__fmsLoaded) return;
  window.__fmsLoaded = true;

  var STORE_KEY = 'fms:measurements:v2';
  var CM_PER_IN = 2.54;
  var DEFAULT_LABEL = 'Find My Size';
  var RESULT_MS = 2000; // progress bar fills in 2 seconds, then the popup closes and the size is selected

  // Which measurements decide the size (inches only).
  var MATCH_ON = ['bust', 'waist'];

  var FIELDS = [
    { key: 'bust', label: 'Bust' },
    { key: 'waist', label: 'Waist' }
  ];

  var autoDone = {}; // dialog id -> true once we have auto-selected a size on this page

  /* ---------- chart parsing ---------- */
  function num(v) {
    if (v == null) return null;
    if (typeof v === 'number') return isFinite(v) ? v : null;
    var m = String(v).match(/\d+(\.\d+)?/g);
    return m ? parseFloat(m[m.length - 1]) : null; // "34-36" -> 36
  }
  function normKey(k) { return String(k).toLowerCase().replace(/[^a-z]/g, ''); }
  function round1(n) { return Math.round(n * 10) / 10; }

  function rowsFrom(data) {
    var rows = [];
    if (Array.isArray(data)) rows = data;
    else if (data && Array.isArray(data.sizes)) rows = data.sizes;
    else if (data && Array.isArray(data.rows)) rows = data.rows;
    else if (data && typeof data === 'object') {
      Object.keys(data).forEach(function (k) {
        if (k === 'unit' || !data[k] || typeof data[k] !== 'object') return;
        var r = { size: k };
        Object.keys(data[k]).forEach(function (kk) { r[kk] = data[k][kk]; });
        rows.push(r);
      });
    }
    var out = [];
    rows.forEach(function (r) {
      var o = {};
      Object.keys(r).forEach(function (k) { o[normKey(k)] = r[k]; });
      var size = o.size || o.name || o.label;
      if (!size) return;
      var row = { size: String(size).trim() };
      FIELDS.forEach(function (f) {
        var v = o[f.key];
        if (v === undefined) {
          var kk = Object.keys(o).filter(function (x) { return x.indexOf(f.key) === 0; })[0];
          if (kk) v = o[kk];
        }
        row[f.key] = num(v);
      });
      out.push(row);
    });
    return out;
  }

  // -> { sizes: [ { size, in:{bust,waist,bottomlength,shoulder}, cm:{...} } ] }
  function parseChart(raw) {
    var data = raw;
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { return null; } }
    if (!data) return null;

    var inRows = null, cmRows = null;
    if (!Array.isArray(data) && (data.in || data.inches || data.cm)) {
      if (data.in || data.inches) inRows = rowsFrom(data.in || data.inches);
      if (data.cm) cmRows = rowsFrom(data.cm);
    } else {
      var rows = rowsFrom(data);
      var u = String((data && data.unit) || 'in').toLowerCase();
      if (u.indexOf('cm') === 0) cmRows = rows; else inRows = rows;
    }
    var base = inRows && inRows.length ? inRows : cmRows;
    if (!base || !base.length) return null;

    function find(list, size) {
      if (!list) return null;
      for (var i = 0; i < list.length; i++) if (list[i].size.toLowerCase() === size.toLowerCase()) return list[i];
      return null;
    }
    return {
      sizes: base.map(function (b) {
        var i = find(inRows, b.size), c = find(cmRows, b.size), vin = {}, vcm = {};
        FIELDS.forEach(function (f) {
          var a = i ? i[f.key] : null, d = c ? c[f.key] : null;
          if (a == null && d != null) a = round1(d / CM_PER_IN);
          if (d == null && a != null) d = round1(a * CM_PER_IN);
          vin[f.key] = a; vcm[f.key] = d;
        });
        return { size: b.size, 'in': vin, cm: vcm };
      })
    };
  }

  function getChart(dlg) {
    if (dlg.__fmsChart !== undefined) return dlg.__fmsChart;
    var chart = null;
    try { chart = parseChart(JSON.parse(dlg.querySelector('script[data-fms-chart]').textContent)); } catch (e) {}
    dlg.__fmsChart = chart;
    return chart;
  }

  // m = measurements in inches (null when not given). Chart is in ascending size order:
  // smallest size that fits every measurement we match on; between sizes -> size up.
  function recommend(chart, m) {
    for (var i = 0; i < chart.sizes.length; i++) {
      var row = chart.sizes[i]['in'], ok = true;
      for (var j = 0; j < MATCH_ON.length; j++) {
        var k = MATCH_ON[j];
        if (m[k] != null && row[k] != null && m[k] > row[k]) { ok = false; break; }
      }
      if (ok) return chart.sizes[i];
    }
    return null;
  }

  /* ---------- saved measurements ---------- */
  function loadSaved() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function save(obj) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  /* ---------- variant picker ---------- */
  function findLabel(fieldset, size) {
    if (!fieldset) return null;
    var target = String(size).trim().toLowerCase();
    var labels = fieldset.querySelectorAll('label.block-swatch');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase() === target) return labels[i];
    }
    return null;
  }
  function isSoldOut(label) { return !!label && label.classList.contains('is-disabled'); }

  function selectLabel(label) {
    var input = label.htmlFor ? document.getElementById(label.htmlFor) : label.querySelector('input');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ---------- trigger label ---------- */
  function setLabel(trigger, text, isSet) {
    var el = trigger.querySelector('[data-fms-label]');
    if (el && el.textContent !== text) el.textContent = text;
    trigger.classList.toggle('is-set', !!isSet);
  }

  // Shows "Your Size: M" (or resets to "Find My Size") for one trigger; optionally selects the size.
  function applyToTrigger(trigger, autoSelect) {
    trigger.setAttribute('data-fms-ready', '');
    var saved = loadSaved();
    var dlg = document.getElementById(trigger.getAttribute('data-fms-open'));
    var chart = dlg && getChart(dlg);
    var entry = saved && saved.m && chart ? recommend(chart, saved.m) : null;
    if (!entry) { setLabel(trigger, DEFAULT_LABEL, false); return null; }

    var label = findLabel(trigger.closest('fieldset'), entry.size);
    var soldOut = isSoldOut(label);
    setLabel(trigger, 'Your Size: ' + entry.size + (soldOut ? ' (sold out)' : ''), true);

    // auto-select once per page load, never over an explicit ?variant= in the URL
    if (autoSelect && label && !soldOut && !autoDone[dlg.id] && !document.querySelector('dialog.fms-dialog[open]') && !/[?&]variant=/.test(location.search)) {
      autoDone[dlg.id] = true;
      selectLabel(label);
    }
    return { entry: entry, label: label, soldOut: soldOut };
  }

  function initAll() {
    document.querySelectorAll('.fms-trigger').forEach(function (t) { applyToTrigger(t, true); });
  }

  /* ---------- popup form ---------- */
  function clearResult(dlg) {
    clearTimeout(dlg.__fmsTimer);
    dlg.__fmsFinish = null;
    var r = dlg.querySelector('[data-fms-result]'); if (r) r.remove();
    var b = dlg.querySelector('.fms-submit'); if (b) b.disabled = false;
    var f = dlg.querySelector('[data-fms-form]'); if (f) { f.classList.remove('is-result'); f.style.minHeight = ''; }
  }
  function mk(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function showResult(form, size, soldOut) {
    var el = form.querySelector('[data-fms-result]');
    if (el) el.remove();
    form.style.minHeight = form.offsetHeight + 'px'; // keep popup height steady when the fields are hidden
    form.classList.add('is-result');
    el = mk('div', 'fms-result');
    el.setAttribute('data-fms-result', '');
    el.setAttribute('role', 'status');

    // "Perfect match" tag with check icon
    var tag = mk('span', 'fms-result__tag');
    tag.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    tag.appendChild(document.createTextNode('Perfect match'));
    el.appendChild(tag);

    el.appendChild(mk('p', 'fms-result__label', 'Your recommended size'));

    // big size badge (kept as <strong> inside .fms-result__text for compatibility)
    var t = mk('p', 'fms-result__text');
    t.appendChild(mk('strong', 'fms-result__size', size));
    el.appendChild(t);

    // measurement chips
    var bustEl = form.querySelector('[data-fms-bust]');
    var waistEl = form.querySelector('[data-fms-waist]');
    var chips = mk('div', 'fms-result__chips');
    if (bustEl && bustEl.value) chips.appendChild(mk('span', 'fms-result__chip', 'Bust ' + bustEl.value + '\u2033'));
    if (waistEl && waistEl.value) chips.appendChild(mk('span', 'fms-result__chip', 'Waist ' + waistEl.value + '\u2033'));
    if (chips.childNodes.length) el.appendChild(chips);

    if (soldOut) {
      el.appendChild(mk('p', 'fms-result__note', 'This size is currently sold out.'));
    }

    // auto-close hint + progress bar
    el.appendChild(mk('p', 'fms-result__auto', 'Selecting this size for you\u2026'));
    var bar = mk('span', 'fms-result__bar');
    var fill = document.createElement('i');
    fill.style.animationDuration = RESULT_MS + 'ms';
    bar.appendChild(fill);
    el.appendChild(bar);

    form.insertBefore(el, form.querySelector('.fms-submit'));
  }

  function prefill(dlg) {
    clearResult(dlg);
    var saved = loadSaved();
    var f = dlg.querySelector('[data-fms-form]');
    f.querySelectorAll('[data-fms-field]').forEach(function (x) { x.classList.remove('has-error'); });
    f.querySelector('[data-fms-error]').hidden = true;
    if (saved && saved.m) {
      FIELDS.forEach(function (fd) {
        var input = f.querySelector('[data-fms-' + fd.key + ']');
        if (!input) return;
        input.value = saved.m[fd.key] != null ? round1(saved.m[fd.key]) : '';
      });
    }
  }

  /* ---------- background scroll lock ---------- */
  var lockY = 0, locked = false;
  function lockScroll() {
    if (locked) return;
    locked = true;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('fms-lock');
    document.body.classList.add('fms-lock');
    document.body.style.top = (-lockY) + 'px';
  }
  function unlockScroll() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('fms-lock');
    document.body.classList.remove('fms-lock');
    document.body.style.top = '';
    window.scrollTo(0, lockY);
  }
  // 'close' doesn't bubble, so listen in capture phase (covers X, Esc, backdrop, submit)
  document.addEventListener('close', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('fms-dialog')) {
      unlockScroll();
      if (e.target.__fmsFinish) e.target.__fmsFinish(); // closed early (X / Esc): still apply the size
    }
  }, true);

  /* ---------- events (delegated so they survive section re-renders) ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-fms-open]');
    if (openBtn) {
      var dlg = document.getElementById(openBtn.getAttribute('data-fms-open'));
      if (!dlg) return;
      prefill(dlg);
      // preview override: ?fms_variant=bold|luxe|line|ticket|c-classic|c-glow|c-double|c-check|c-night|default
      var pv = (location.search.match(/[?&]fms_variant=([a-z0-9-]+)/) || [])[1];
      if (pv) { if (pv === 'default') dlg.removeAttribute('data-fms-variant'); else dlg.setAttribute('data-fms-variant', pv); }
      dlg.showModal();
      lockScroll();
      return;
    }
    if (e.target.closest && e.target.closest('[data-fms-close]')) {
      var d = e.target.closest('dialog'); if (d) d.close();
      e.preventDefault();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.fms-dialog')) e.target.close(); // backdrop click
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-fms-form]') : null;
    if (!form) return;
    e.preventDefault();

    var dlg = form.closest('dialog');
    var err = form.querySelector('[data-fms-error]');
    err.hidden = true;
    form.querySelectorAll('[data-fms-field]').forEach(function (f) { f.classList.remove('has-error'); });

    var chart = getChart(dlg);
    if (!chart) { err.textContent = 'Size chart is not available for this product.'; err.hidden = false; return; }

    // read measurements -> inches
    var m = {}, invalid = [], missing = [];
    FIELDS.forEach(function (fd) {
      var input = form.querySelector('[data-fms-' + fd.key + ']');
      var raw = input.value.trim();
      var required = true;
      if (raw === '') {
        m[fd.key] = null;
        if (required) missing.push(fd);
        return;
      }
      var v = parseFloat(raw);
      if (!(v > 0)) { invalid.push(fd); m[fd.key] = null; return; }
      m[fd.key] = v; // inches
    });

    var bad = missing.concat(invalid);
    if (bad.length) {
      bad.forEach(function (fd) { form.querySelector('[data-fms-field="' + fd.key + '"]').classList.add('has-error'); });
      var names = bad.map(function (fd) { return fd.label.toLowerCase(); }).join(', ');
      err.textContent = 'Please enter a valid measurement for: ' + names + '.';
      err.hidden = false;
      return;
    }

    var entry = recommend(chart, m);
    if (!entry) {
      err.textContent = 'Your measurements are above our largest size. Please contact us for a custom fit.';
      err.hidden = false;
      return;
    }

    save({ m: m });

    var label = findLabel(dlg.closest('fieldset'), entry.size);
    var soldOut = isSoldOut(label);

    // 1) show "Your size is S" inside the popup (don't touch the page yet: picking a size re-renders it)
    showResult(form, entry.size, soldOut);
    form.querySelector('.fms-submit').disabled = true;
    clearTimeout(dlg.__fmsTimer);

    // 2) after a few seconds (or if the customer closes it earlier): close, show "Your Size: S", select the size
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      clearTimeout(dlg.__fmsTimer);
      dlg.__fmsFinish = null;
      if (dlg.open) { try { dlg.close(); } catch (x) { dlg.removeAttribute('open'); unlockScroll(); } }
      function showAll() { document.querySelectorAll('.fms-trigger').forEach(function (t) { applyToTrigger(t, false); }); }
      showAll();
      if (label && !soldOut) selectLabel(label);
      // the product section re-renders after a size change and rebuilds the link; re-apply so it stays "Your Size: S"
      [250, 800, 1800].forEach(function (ms) { setTimeout(showAll, ms); });
    }
    dlg.__fmsFinish = finish;
    dlg.__fmsTimer = setTimeout(finish, RESULT_MS);
  });

  /* ---------- boot ---------- */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // handle triggers inserted later (section re-renders, quick views)
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      if (document.querySelector('.fms-trigger:not([data-fms-ready])')) initAll();
    });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();